// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1yWYx","addWidgetButton":"Header_addWidgetButton__2-LZr","dashboardTabs":"Header_dashboardTabs__2yqhG","active":"Header_active__2OrK_"};